export default "__VITE_ASSET__B3dR0lUy__"